<div class="modal-body _pop-overlay _math-key-popup">
  <div class="mid-panel">
    <div class="_pop-mid-content _math-key-popup rounded-modal" appModalFocusOnInit="100" tabindex="-1">
      <div class="_math-key-mid">
        <div class="_top-icon">
          <img src="assets/images/access-code-modal-icon.svg" width="80" aria-hidden="true" />
        </div>
        <!-- <div class="heading">Terms and Condition</div> -->
        <div class="_form-section _terms-popup2 mt-3">
          <div class="_left-form">
            <form [formGroup]="accessCodeForm" (ngSubmit)="onSubmit()">
              <div class="form-field">
                <div class="_field w-100 mx-0">
                  <h3 class="font-weight-bold ml-3 mb-5">
                    {{ 'signupAccessModalHeading' | translate }}
                  </h3>
                  <p class="text-left w-100 ml-3">{{ 'signupAccessModalDescription.0' | translate }} <br /></p>
                  <p class="text-left w-100 ml-3">
                    {{ 'signupAccessModalDescription.1' | translate }}
                    <strong>{{ 'signupAccessModalDescription.2' | translate }}</strong>
                  </p>
                  <div class="form-field _checkbox mb-3 mt-2">
                    <div class="form-group">
                      <input tabindex="-1" type="checkbox" id="acccessCheckbox" formControlName="isShowAccessCode" />
                      <label (keyup.enter)="toggleLicenseCodeField()" for="acccessCheckbox" tabindex="0"></label>
                    </div>
                    <div class="_terms">
                      <span> {{ 'signupAccessModalCheckboxText' | translate }} </span>
                    </div>
                  </div>

                  <div class="mx-2" *ngIf="accessCodeForm.controls.isShowAccessCode.value">
                    <input
                      type="text"
                      class="pl-4"
                      autocomplete="off"
                      maxlength="11"
                      placeholder="{{ 'signupAccessModalInputPlaceholder' | translate }}"
                      formControlName="licenseCode"
                    />
                    <label
                      for=""
                      *ngIf="
                        accessCodeForm.get('licenseCode')?.errors?.required &&
                        accessCodeForm.get('licenseCode')?.invalid &&
                        accessCodeForm.get('licenseCode')?.touched
                      "
                      class="error-msg"
                    >
                      {{ 'licenseCodeRequired' | translate }}
                    </label>
                    <label
                      for=""
                      *ngIf="
                        accessCodeForm.get('licenseCode')?.errors?.maxlength &&
                        accessCodeForm.get('licenseCode')?.invalid &&
                        accessCodeForm.get('licenseCode')?.touched
                      "
                      class="error-msg"
                    >
                      {{ 'licenseCodeMax' }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="text-center form-field _submit terms_submit mt-1">
                <div class="text-center w-50">
                  <button [disabled]="accessCodeForm.invalid" type="submit" class="button secondary w-100">
                    {{ 'signupAccessModalBtn' | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
